import { toast } from "react-toastify";

export const CountryGuideModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const codeExample = `{
  code: "kz",
  phoneFormat: "+7 (###) ### ## ##",
  name: "Kazakhstan",
  phoneCode: "+7",
  length: 12,
  codeSlice: /^\\+7/,
  digitsLength: 10,
}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      <div className="relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-xl mx-4 overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-white text-lg font-semibold mb-0">
              Mamlakat qo'shish bo'yicha qo'llanma
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 transition-colors text-xl font-bold leading-none"
          >
            ✕
          </button>
        </div>

        <div className="px-6 py-5 space-y-4 text-sm text-gray-700">
          <p>
            Yangi mamlakat ma'lumotlarini to'g'ri kiritish uchun quyidagi
            ko'rsatmalarga amal qiling:
          </p>

          <ul className="list-decimal list-inside space-y-2 leading-relaxed">
            <li>
              Quyidagi JSON namunasini <strong>AI (ChatGPT, Gemini, va h.k.)</strong> ga yuboring.
            </li>
            <li>
              So'rovga <strong>kerakli mamlakat nomini</strong> ham yozing,
              masalan: <em>"menga Uzbekistan uchun tayyorlab ber"</em>.
            </li>
            <li>
              AI qaytargan ma'lumotni formaga joylashtiring.
            </li>
            <li>
              <strong>Flag rasmi</strong> uchun{" "}
              <a
                href="https://flagpedia.net"
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                flagpedia.net
              </a>{" "}
              saytiga o'ting → mamlakatni toping → <strong>Mini waving icon</strong> turini tanlang → <strong>72×54 px</strong> size →  da yuklab oling va File maydoniga yuklang.
            </li>
          </ul>

          <div>
            <p className="font-semibold text-gray-800 mb-1">
              AI ga beriladigan namuna kod:
            </p>
            <div className="relative">
              <pre className="bg-gray-900 text-green-400 rounded-lg p-4 text-xs overflow-x-auto leading-relaxed">
                {codeExample}
              </pre>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(codeExample);
                  toast.info("Kod nusxalandi!", {
                    position: "bottom-right",
                    autoClose: 2000,
                  });
                }}
                className="absolute top-2 right-2 bg-gray-700 hover:bg-gray-600 text-white text-xs px-2 py-1 rounded transition-colors"
              >
                Nusxa olish
              </button>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-blue-800 text-xs">
            💡 <strong>Maslahat:</strong> AI ga yuborganingizda shunday yozing:{" "}
            <em>
              "Quyidagi code ni copy qilib oling va <strong>[mamlakat nomi]</strong> uchun
              tayyorlab bering"
            </em>
          </div>
        </div>

        <div className="px-6 py-4 bg-gray-50 flex justify-end border-t border-gray-100">
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors"
          >
            Tushunarli, boshlaylik!
          </button>
        </div>
      </div>
    </div>
  );
};